import React, { useState } from "react";
import { Send, Check } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;
const SIZES = ["S", "M", "L", "XL", "XXL"];
const BATS = [
  { src: "/img/exc_scene/a4.webp", style: { top: "6%", left: "4%", width: 54, transform: "rotate(-14deg)" } },
  { src: "/img/exc_scene/a6.webp", style: { top: "12%", right: "5%", width: 34, transform: "rotate(10deg)" } },
  { src: "/img/exc_scene/a7.webp", style: { bottom: "10%", left: "7%", width: 48, transform: "rotate(8deg)" } },
  { src: "/img/exc_scene/a5.webp", style: { bottom: "6%", right: "8%", width: 44, transform: "rotate(-8deg)" } },
  { src: "/img/exc_scene/a8.webp", style: { top: "44%", right: "2%", width: 22, transform: "rotate(4deg)" } },
];

export const ExcPreorder = () => {
  const [form, setForm] = useState({ full_name: "", size: "M", phone: "", email: "", instagram: "", wants_model: false });
  const [state, setState] = useState("idle");
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setState("busy");
    setErr("");
    try {
      const res = await fetch(`${API}/api/excourtier/preorder`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });
      const data = await res.json();
      if (res.ok) setState("ok");
      else { setState("error"); setErr(data.detail || "Couldn't sign up."); }
    } catch {
      setState("error"); setErr("Couldn't sign up — try again.");
    }
  };

  return (
    <section className="exc-preorder" data-testid="exc-preorder">
      {BATS.map((b, i) => (
        <img key={i} src={b.src} alt="" className="exc-preorder-bat" style={b.style} draggable={false} />
      ))}
      <h3 className="req-title">Pre-order sign up</h3>
      <p className="shirt-member-note">Sign up and a 10% discount flies straight to your inbox — look closely at the bats.</p>
      {state === "ok" ? (
        <div className="shirt-claim-ok" data-testid="exc-preorder-ok">
          <Check size={16} /> You're in. Check your email — one of the bats is holding your discount.
        </div>
      ) : (
        <form className="req-form exc-preorder-form" onSubmit={submit} data-testid="exc-preorder-form">
          <div className="req-grid">
            <label className="req-field"><span className="req-label">Full name*</span>
              <input className="req-input" required value={form.full_name} data-testid="exc-pre-name"
                onChange={(e) => setForm({ ...form, full_name: e.target.value })} /></label>
            <label className="req-field"><span className="req-label">Size*</span>
              <select className="req-input" value={form.size} data-testid="exc-pre-size"
                onChange={(e) => setForm({ ...form, size: e.target.value })}>
                {SIZES.map((s) => <option key={s} value={s}>{s}</option>)}
              </select></label>
            <label className="req-field"><span className="req-label">Number*</span>
              <input className="req-input" type="tel" required value={form.phone} data-testid="exc-pre-phone"
                onChange={(e) => setForm({ ...form, phone: e.target.value })} /></label>
            <label className="req-field"><span className="req-label">Email*</span>
              <input className="req-input" type="email" required value={form.email} data-testid="exc-pre-email"
                onChange={(e) => setForm({ ...form, email: e.target.value })} /></label>
            <label className="req-field"><span className="req-label">Instagram</span>
              <input className="req-input" value={form.instagram} data-testid="exc-pre-ig"
                onChange={(e) => setForm({ ...form, instagram: e.target.value })} placeholder="@you" /></label>
          </div>
          <label className="exc-model-check" data-testid="exc-pre-model">
            <input type="checkbox" checked={form.wants_model}
              onChange={(e) => setForm({ ...form, wants_model: e.target.checked })} />
            <span>I want to model for the brand</span>
          </label>
          <button className="btn-solid" type="submit" disabled={state === "busy"} data-testid="exc-pre-submit">
            <Send size={15} /> {state === "busy" ? "Signing up…" : "Sign up for pre-order"}
          </button>
          {err && <div className="cart-error">{err}</div>}
        </form>
      )}
    </section>
  );
};
